import React from "react";
import Button from "@/bit/components/next13.components.button";
import SimplePhone from "@/bit/components/next13.components.simple-phone";

export const SCX_PATH = `https://{env}.cms.col.movistar.es/static/js/scx/scx.js`;

function ActionCallModule({
  simplePhone,
  button,
  isButtonFull,
  skeletonClassName,
}) {
  const taggingInfo = {
    componentName: "buy-box",
    componentVariation: "all",
    componentContent: button && button.label ? button.label : "",
    componentProduct: button.alias || "",
    eventType: "click",
  };

  return (
    <div className={`call-to-action ${simplePhone && simplePhone.belowPrice ? 'phone-below-price' : 'phone-normal'}`}>
      {simplePhone && <SimplePhone {...simplePhone} />}

      <div
        className={`buy-box-content-button ${
          isButtonFull
            ? "buy-box-content-button-full"
            : "buy-box-content-button"
        }`}
      >
        <div
          className={`skeleton skeleton-buybox skeleton-button ${skeletonClassName}`}
        >
          {button && (
            <Button
              className="principal-button"
              {...button}
              taggingInfo={taggingInfo}
              cyData="BuyBox Button-1"
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default ActionCallModule;